const SINGLE_PRICE = 1800;
const BUNDLE_PRICE = 3000;
const SHOPIFY_CART_URL = "https://nautankibynaina.com/cart/";
const SHOPIFY_HOST = "nautankibynaina.com";
const PRODUCT_VARIANTS = {
  centered: {
    S: 49688753340700,
    M: 49688753373468,
    L: 49688753406236,
    XL: 49688753439004,
    "2XL": 49688753471772,
  },
  hope: {
    S: 49689075548444,
    M: 49689075581212,
    L: 49689075613980,
    XL: 49689075646748,
    "2XL": 49689075679516,
  },
  greatful: {
    S: 49691162345756,
    M: 49691162378524,
    L: 49691162411292,
    XL: 49691162444060,
    "2XL": 49691162476828,
  },
  manifest: {
    S: 49688911708444,
    M: 49688911741212,
    L: 49688911773980,
    XL: 49688911806748,
    "2XL": 49688911839516,
  },
  chaos: {
    S: 49691514831132,
    M: 49691514863900,
    L: 49691514896668,
    XL: 49691514929436,
    "2XL": 49691514962204,
  },
  fomo: {
    S: 49691550548252,
    M: 49691550581020,
    L: 49691550613788,
    XL: 49691550646556,
    "2XL": 49691550679324,
  },
  "lost-in-reality": {
    S: 49691623817500,
    M: 49691623850268,
    L: 49691623883036,
    XL: 49691623915804,
    "2XL": 49691623948572,
  },
};

const cart = [];
const cartCount = document.querySelector("#cart-count");
const cartMessage = document.querySelector("#cart-message");
const cartSelected = document.querySelector("#cart-selected");
const cartTotal = document.querySelector("#cart-total");
const cartSavings = document.querySelector("#cart-savings");
const stickyCount = document.querySelector("#sticky-count");
const stickyTotal = document.querySelector("#sticky-total");
const cartLinks = document.querySelectorAll("[data-cart-link]");
const isShopifyStore =
  window.location.hostname === SHOPIFY_HOST ||
  window.location.hostname.endsWith(`.${SHOPIFY_HOST}`) ||
  window.location.hostname.endsWith(".myshopify.com");

function formatPrice(value) {
  return `Rs. ${value.toLocaleString("en-IN")}`;
}

function getCartQuantity() {
  return cart.reduce((total, item) => total + item.quantity, 0);
}

function getBundleTotal(quantity) {
  const pairs = Math.floor(quantity / 2);
  const singles = quantity % 2;
  return pairs * BUNDLE_PRICE + singles * SINGLE_PRICE;
}

function getCartUrl() {
  if (isShopifyStore) return "/cart";
  if (cart.length === 0) return SHOPIFY_CART_URL;

  const items = cart
    .map((item) => `${item.variantId}:${item.quantity}`)
    .join(",");

  return `${SHOPIFY_CART_URL}${items}`;
}

async function requestShopifyCart(path, options = {}) {
  const response = await fetch(path, {
    credentials: "same-origin",
    headers: {
      Accept: "application/json",
      ...(options.body ? { "Content-Type": "application/json" } : {}),
    },
    ...options,
  });

  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    throw new Error(error.description || "Could not update the cart.");
  }

  return response.json();
}

async function getShopifyVariantQuantity(variantId) {
  const shopifyCart = await requestShopifyCart("/cart.js");

  return shopifyCart.items.reduce((quantity, item) => {
    return item.variant_id === variantId ? quantity + item.quantity : quantity;
  }, 0);
}

async function setShopifyVariantQuantity(variantId, quantity) {
  if (!isShopifyStore) return;

  await requestShopifyCart("/cart/update.js", {
    method: "POST",
    body: JSON.stringify({
      updates: {
        [variantId]: quantity,
      },
    }),
  });
}

async function addShopifyCartQuantity(variantId, quantity) {
  if (!isShopifyStore) return;

  const currentQuantity = await getShopifyVariantQuantity(variantId);
  await setShopifyVariantQuantity(variantId, currentQuantity + quantity);
}

function updateSelectedCards() {
  document.querySelectorAll("[data-product-card]").forEach((card) => {
    const productId = card.dataset.productCard;
    const isSelected = cart.some((item) => item.id === productId);
    card.classList.toggle("is-selected", isSelected);
  });
}

function renderCart() {
  const quantity = getCartQuantity();
  const total = getBundleTotal(quantity);
  const regularTotal = quantity * SINGLE_PRICE;
  const saving = regularTotal - total;

  cartCount.textContent = `${quantity} ${quantity === 1 ? "tee" : "tees"} added`;
  cartTotal.textContent = formatPrice(total);
  stickyCount.textContent = `${quantity} ${quantity === 1 ? "mood" : "moods"}`;
  stickyTotal.textContent = formatPrice(total);
  cartLinks.forEach((link) => {
    link.href = getCartUrl();
    link.setAttribute("aria-disabled", quantity === 0 ? "true" : "false");
  });

  if (quantity === 0) {
    cartMessage.textContent = "Add any two tees to unlock Rs. 3,000 + free shipping + signed postcard.";
    cartSavings.textContent = "Bundle price appears after two tees.";
    cartSelected.innerHTML = "<span>No moods picked yet.</span>";
  } else if (quantity === 1) {
    cartMessage.textContent = "Add one more mood to unlock the two-tee bundle.";
    cartSavings.textContent = "One tee price: Rs. 1,800.";
    cartSelected.innerHTML = "";
  } else {
    cartMessage.textContent = "Bundle unlocked. Free shipping + signed postcard applies.";
    cartSavings.textContent = saving > 0 ? `You save ${formatPrice(saving)}.` : "Bundle unlocked.";
    cartSelected.innerHTML = "";
  }

  if (quantity > 0) {
    cart.forEach((item) => {
      const chip = document.createElement("button");
      chip.type = "button";
      chip.dataset.removeKey = item.key;
      chip.textContent = `${item.name} ${item.size} x${item.quantity}`;
      chip.setAttribute("aria-label", `Remove ${item.name} size ${item.size}`);
      cartSelected.appendChild(chip);
    });
  }

  updateSelectedCards();
}

document.querySelectorAll('a[href^="#"]').forEach((link) => {
  link.addEventListener("click", (event) => {
    const target = document.querySelector(link.getAttribute("href"));

    if (!target) return;

    event.preventDefault();
    target.scrollIntoView({ behavior: "smooth", block: "start" });
  });
});

document.querySelectorAll(".add-product").forEach((button) => {
  button.addEventListener(
    "click",
    async (event) => {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

    const { productId, productName, mood } = button.dataset;
    const sizeField = document.querySelector(`[data-size="${productId}"]`);
    const size = sizeField ? sizeField.value : "M";
    const variantId = PRODUCT_VARIANTS[productId]?.[size];
    const key = `${productId}-${size}`;
    const existingItem = cart.find((item) => item.key === key);

    if (!variantId) {
      window.location.href = button.dataset.productUrl;
      return;
    }

    button.disabled = true;
    button.textContent = "Adding";

    try {
      await addShopifyCartQuantity(variantId, 1);
    } catch (error) {
      button.disabled = false;
      button.textContent = "Try again";
      cartMessage.textContent = error.message;
      window.setTimeout(() => {
        button.textContent = "Add mood";
      }, 1400);
      return;
    }

    if (existingItem) {
      existingItem.quantity += 1;
    } else {
      cart.push({
        key,
        id: productId,
        name: productName,
        mood,
        size,
        variantId,
        quantity: 1,
      });
    }

    button.classList.add("is-added");
    button.textContent = "Added";
    window.setTimeout(() => {
      button.disabled = false;
      button.classList.remove("is-added");
      button.textContent = "Add mood";
    }, 950);

    renderCart();
    },
    true
  );
});

document.querySelectorAll(".add-product").forEach((button) => {
  const form = button.closest("form");

  if (!form) return;

  form.addEventListener("submit", (event) => {
    if (event.submitter === button) {
      event.preventDefault();
      event.stopPropagation();
    }
  });
});

cartSelected.addEventListener("click", async (event) => {
  const removeKey = event.target.dataset.removeKey;

  if (!removeKey) return;

  const itemIndex = cart.findIndex((item) => item.key === removeKey);
  if (itemIndex === -1) return;

  const item = cart[itemIndex];
  const nextQuantity = item.quantity > 1 ? item.quantity - 1 : 0;

  event.target.disabled = true;

  try {
    await setShopifyVariantQuantity(item.variantId, nextQuantity);
  } catch (error) {
    event.target.disabled = false;
    cartMessage.textContent = error.message;
    return;
  }

  if (cart[itemIndex].quantity > 1) {
    cart[itemIndex].quantity -= 1;
  } else {
    cart.splice(itemIndex, 1);
  }

  renderCart();
});

document.querySelector("[data-clear-cart]").addEventListener("click", async () => {
  const updates = cart.reduce((allUpdates, item) => {
    allUpdates[item.variantId] = 0;
    return allUpdates;
  }, {});

  if (isShopifyStore && Object.keys(updates).length > 0) {
    try {
      await requestShopifyCart("/cart/update.js", {
        method: "POST",
        body: JSON.stringify({ updates }),
      });
    } catch (error) {
      cartMessage.textContent = error.message;
      return;
    }
  }

  cart.splice(0, cart.length);
  renderCart();
});

renderCart();
